import { Component, inject, Input, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ShopProductGroupService } from 'src/app/connect-api/api/shop/shop-product-group.service';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
  selector: 'app-shop-group-form',
  templateUrl: './shop-group-form.component.html',
  styleUrl: './shop-group-form.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class ShopGroupFormComponent {
  @Input({ required: true }) category: Partial<any>;

  protected shopProductGroupService = inject(ShopProductGroupService);
  private messageService = inject(MessageService);
  private router = inject(Router);

  public groupForm = new FormGroup({
    name: new FormControl<string>('', {
      nonNullable: true,
      validators: [Validators.required]
    }),
    description: new FormControl<string | undefined>(undefined),
    markupMin: new FormControl<number>(null, {
      nonNullable: true,
      validators: [Validators.required, Validators.min(0.1)]
    }),
    markupWithoutCompetitor: new FormControl<number>(null, {
      nonNullable: true,
      validators: [Validators.required, Validators.min(0.1)]
    }),
    discountCompetitor: new FormControl<number>(null, {
      nonNullable: true,
      validators: [Validators.required, Validators.min(0.1)]
    }),
    subscriberDiscountPercentage: new FormControl<number>(null, {
      nonNullable: true,
      validators: [Validators.required, Validators.min(0.1)]
    }),
    dynamicPrecification: new FormControl<boolean>(false)
  });

  async submit(): Promise<void> {
    if (!this.groupForm.valid) {
      this.groupForm.markAllAsTouched();
      this.groupForm.markAsDirty();
      this.messageService.add({
        severity: 'error',
        summary: 'Erro',
        detail: 'Verifique os campos'
      });
      return;
    }

    try {
      LoaderService.showLoader(true);

      const group = await this.shopProductGroupService.create(this.groupData);

      LoaderService.showLoader(false);

      this.messageService.add({
        severity: 'success',
        summary: 'Sucesso',
        detail: 'Grupo criado com sucesso'
      });

      this.router.navigate(['/shop/products/groups', group.id]);
    } catch (error) {
      this.messageService.add({
        severity: 'error',
        summary: 'Erro',
        detail: 'Erro ao criar o grupo'
      });
    }

    return;
  }

  invalidControl(control: string): boolean {
    return (
      this.groupForm.controls[control].invalid &&
      (this.groupForm.controls[control].dirty ||
        this.groupForm.controls[control].touched)
    );
  }

  get groupData(): Partial<any> {
    return this.groupForm.getRawValue();
  }
}
